var _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseMovingIcon = function SvgHouseMovingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#house-moving-icon_svg__a)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.31,
    cy: 11.9,
    r: 11.5,
    fill: "url(#house-moving-icon_svg__b)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.31,
    cy: 11.9,
    r: 11.5,
    fill: "url(#house-moving-icon_svg__c)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "house-moving-icon_svg__e",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.31,
    cy: 11.9,
    r: 11.5,
    fill: "url(#house-moving-icon_svg__d)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#house-moving-icon_svg__e)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__f)",
    d: "M19.31 6.3v12.235H.03V6.3l9.64-4.079z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CEC3BE",
    d: "M17.671 14.9h-3.388v.249h3.388z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1842B5",
    d: "M17.176 8.804H14.08v3.98h3.096zM5.233 8.804H2.137v3.98h3.096z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAE6",
    d: "M17.671 14.472h-3.388v.428h3.388z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.176 9.12v.657l-1.237 1.07-.731.635-1.128.976v-.657l1.128-.976.731-.633zM16.93 8.804l-2.85 2.468V8.804zM5.233 9.12v.657l-1.236 1.07-.731.635-1.129.976v-.657l1.129-.976.73-.633zM4.987 8.804l-2.85 2.468V8.804z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E35600",
    d: "M20.388 7.165 9.917 2.785-.555 7.166l-.404-.89L9.917 1.726l10.875 4.547z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CEC3BE",
    d: "M11.754 6.682c0 .98-.853 1.775-1.908 1.775-.5 0-.954-.18-1.294-.471a1.751 1.751 0 0 1-.524-.768 1.7 1.7 0 0 1-.089-.536c0-.98.852-1.774 1.907-1.774.2 0 .394.029.574.084.146.04.286.101.415.174q.23.129.41.312c.313.316.508.74.508 1.204z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAE6",
    d: "M11.754 6.467c0 .98-.853 1.776-1.908 1.776-.5 0-.954-.181-1.294-.472a1.751 1.751 0 0 1-.524-.768 1.7 1.7 0 0 1-.089-.536c0-.98.852-1.774 1.907-1.774.2 0 .394.03.574.084.146.04.286.102.415.174q.23.129.41.312c.313.316.508.74.508 1.204z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1842B5",
    d: "M11.38 6.467c0 .788-.688 1.427-1.534 1.427-.403 0-.769-.145-1.041-.38a1.403 1.403 0 0 1-.422-.617 1.4 1.4 0 0 1-.07-.43c0-.788.685-1.427 1.533-1.427q.243.001.461.068.179.049.333.14.186.104.332.25c.251.254.407.596.407.969"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#AECCFF",
    d: "m10.972 5.498-.507.472-.58.539-.511.476-.38.354-.19.176a1.5 1.5 0 0 1-.27-.307l.26-.242.58-.54.512-.476.466-.434.113-.105.175-.163q.186.104.332.25M10.307 5.108l-1.924 1.79a1.4 1.4 0 0 1-.07-.431c0-.788.685-1.427 1.533-1.427q.243.001.461.068"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#302B86",
    d: "M12.883 11.014H6.456v7.415h6.427z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE9E9",
    d: "M11.4 12.002H7.94v6.427h3.46z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.905 17.934v-5.437H8.434v5.437z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEBE6",
    d: "M13.377 10.52H5.962v.494h7.415z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1842B5",
    d: "M16.514 9.222H14.21v3.766h2.304zM4.572 9.222H2.268v3.766h2.304z",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF943B",
    d: "m16.16 23.355 3.043-1.69v-5.07l-3.2 1.42-.023 5.363h.023c.067.022.113 0 .158-.023"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__g)",
    d: "M10.46 23.378h5.475c.09 0 .158-.068.158-.158v-5.16a.05.05 0 0 0-.045-.045h-5.7a.05.05 0 0 0-.046.045v5.16c-.022.09.068.158.158.158"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__h)",
    d: "M14.358 16.528h5.183l-3.403 1.464c-.022 0-.045.023-.068.023h-5.745l3.74-1.42a.56.56 0 0 1 .293-.067"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE5F00",
    d: "m16.994 19.862-.383 1.172.248-.135v1.42l.27-.158v-1.42l.248-.135zM18.301 20.065l-.383-.743-.383 1.171.248-.135v1.42l.27-.158V20.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__i)",
    d: "m15.98 18.015-.72.045-.722.022c-.473.023-.946.023-1.42.023-.473 0-.946 0-1.419-.023l-.72-.022-.722-.045z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC973",
    d: "M12.43 20.185h1.646V18H12.43z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE7A2B",
    d: "m18.842 17.294-1.555.698.023 1.15 1.555-.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC9C",
    d: "M15.868 16.528h1.622l-3.425 1.487H12.42z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEDB8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.098,
    d: "M12.443 18.015h1.6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__j)",
    d: "m22.22 23.355 3.244-1.69.09-5.115-3.492 1.465-.045 5.363h.022c.09.022.136.022.18-.023"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__k)",
    d: "M16.519 23.4h5.475c.09 0 .158-.067.158-.158v-5.16c0-.022-.023-.045-.045-.045h-5.7a.05.05 0 0 0-.046.045v5.16c0 .09.068.158.158.158"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__l)",
    d: "M20.417 16.55h5.182l-3.402 1.465c-.022 0-.045.022-.067.022h-5.746l3.74-1.42a.56.56 0 0 1 .293-.067"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__m)",
    d: "m22.04 18.037-.722.045-.72.023c-.474.023-.947.023-1.42.023-.474 0-.947 0-1.42-.023l-.72-.023-.722-.045z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC973",
    d: "M18.474 20.195h1.645v-2.186h-1.645z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC9C",
    d: "M21.927 16.55h1.622l-3.425 1.465h-1.622z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEDB8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.098,
    d: "M18.502 18.037h1.6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__n)",
    d: "m19.224 17.97 3.312-1.42v-5.07l-3.447 1.172-.045 5.363h.022a.4.4 0 0 0 .158-.045"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAAA52",
    d: "M13.5 18.015h5.476c.09 0 .158-.068.158-.158v-5.16a.05.05 0 0 0-.045-.045H13.41a.05.05 0 0 0-.045.045v5.16c-.022.068.045.158.136.158"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__o)",
    d: "M17.354 11.458h5.182l-3.357 1.149c-.023 0-.045.023-.068.023h-5.746l3.673-1.105a.7.7 0 0 1 .316-.067"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#house-moving-icon_svg__p)",
    d: "m19.044 12.652-.721.045-.721.023c-.474.022-.947.022-1.42.022s-.946 0-1.42-.022l-.72-.023-.722-.045z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC973",
    d: "M15.475 14.81h1.645v-2.186h-1.645z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC9C",
    d: "M13.343 17.339c-.023-.789-.023-1.577-.023-2.366v-2.411h.045l1.938-.563c.654-.18 1.285-.361 1.938-.541-.63.203-1.284.428-1.915.608l-1.938.586.045-.045-.023 2.366c-.045.788-.045 1.577-.067 2.366"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC9C",
    d: "M18.908 11.458h1.645l-3.425 1.172h-1.645z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFEDB8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.098,
    d: "M15.483 12.63h1.623"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__b",
    x1: 17.839,
    x2: -8.521,
    y1: -2.033,
    y2: 21.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__c",
    x1: 1.474,
    x2: 18.503,
    y1: -2.475,
    y2: 24.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#FFF8EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__d",
    x1: 17.839,
    x2: 5.676,
    y1: -2.033,
    y2: 23.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__f",
    x1: 9.669,
    x2: 9.669,
    y1: 2.221,
    y2: 18.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0770C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__g",
    x1: 13.196,
    x2: 15.703,
    y1: 18.015,
    y2: 24.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC2D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__h",
    x1: 14.933,
    x2: 14.933,
    y1: 16.528,
    y2: 18.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__i",
    x1: 10.934,
    x2: 10.935,
    y1: 17.963,
    y2: 18.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#EC502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#9C6357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__j",
    x1: 22.435,
    x2: 29.808,
    y1: 12.646,
    y2: 21.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#EC502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#9C6357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__k",
    x1: 19.256,
    x2: 21.765,
    y1: 18.037,
    y2: 24.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC502D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__l",
    x1: 20.992,
    x2: 20.992,
    y1: 16.55,
    y2: 18.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__m",
    x1: 16.993,
    x2: 16.994,
    y1: 17.986,
    y2: 18.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#EC502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#9C6357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__n",
    x1: 19.456,
    x2: 26.459,
    y1: 7.752,
    y2: 16.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#EC502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#9C6357"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__o",
    x1: 17.951,
    x2: 17.951,
    y1: 11.458,
    y2: 12.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD591"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD084"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "house-moving-icon_svg__p",
    x1: 13.997,
    x2: 13.998,
    y1: 12.601,
    y2: 12.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    stopColor: "#EC502D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953,
    stopColor: "#9C6357"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "house-moving-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgHouseMovingIcon;